import People from './container';

export default People;



// WEBPACK FOOTER //
// ./src/components/People/index.js